import 'swiper/swiper-bundle.css'
// import 'flickity/dist/flickity.min.css';
import '../styles/main.scss'
import { heroSliders } from "./modules/hero-slider";
import { scrollAnimation } from "./modules/scroll-animation";
import { mclGallery } from "./modules/mcl-gallery";
import { mclHeroSliders } from "./modules/mcl-hero-slider";
import { mclMovingGalleries } from "./modules/mcl-moving-gallery";
import { mclPopups } from "./modules/mcl-popup";
import { youtubePopups } from "./modules/mcl-youtube-popups";
import { lazyLoadMedia } from "./modules/lazy-load-videos";

document.addEventListener('DOMContentLoaded', () => {
    scrollAnimation();
    lazyLoadMedia();
    mclPopups();
    youtubePopups();
    mclHeroSliders();
    mclMovingGalleries();
    heroSliders();
    mclGallery();
});